module.exports = __webpack_public_path__ + "img/thumbnail_ChinesePangolin_f_normal.c7018eac.png";